import { Button } from "controls";
import useLogout from "hooks/useLogout";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t } = useTranslation(['common']);
  const logout = useLogout();
  return (
    <div className="flex items-center justify-between p-[10px] border-b">
      <span className="uppercase font-semibold text-gray-500 ml-[5px] tracking-wide">
        {t('businessUnit')}
      </span>
      <div className="flex gap-2">
        <Button
          onClick={logout}
          variant="text"
          className="!text-red-500 !bg-red-100 !font-medium !uppercase"
        >
          {t('logout')}
        </Button>
        <Button type="submit">{t('continue')}</Button>
      </div>
    </div>
  );
};

export default Header;
